//
import { ModuleLayout } from '@/components/reusable_components/next'
import SaleTicketList from '@/views/SaleTickets/list/SaleTicketList'
import SaleTicketDetail from '@/views/SaleTickets/detail/SaleTicketDetails'
import SaleTicketPending from '@/views/SaleTickets/pending/SaleTicketPending'

//
export default {
    path: 'pos_sales',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'sale-ticket-list',
            component: SaleTicketList,
        },
        {
            path: 'pending',
            name: 'sale-ticket-pending',
            component: SaleTicketPending,
            meta: {
                title: 'Tickets de venta pendientes',
            },
        },
        {
            path: ':id',
            name: 'sale-ticket-detail',
            component: SaleTicketDetail,
            meta: {
                title: 'Detalle de ticket de venta',
            },
        },
    ],
    meta: {
        title: 'Tickets de venta',
    },
}
